import axios from 'axios'

// create an axios instance


const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, //process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if(config.type){

      config.headers['Content-Type'] = config.type

    }else{
      config.headers['Content-Type'] = 'application/json'
    }
    console.log(config.headers['Content-Type'],'config.type')
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res,'resresponse---')
    if (res.code != 0) {
          return res
          return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log(error.response,'error.response')
    // if(error.response.status == 400){

    //   return error.response.data
    // }else{
    //   console.log(error,'errorerror')
    //   return Promise.reject(error)
    // }

  }
)


export default service




// import axios from 'axios'
// let data = {area:1}

// axios.post('/api/v1/index', data, {
//   headers: {
//     'Content-Type': 'application/json'
//   }
// }).then(res=>{

//   console.log(res,'sssssss')

// })





// WEBPACK FOOTER //
// ./src/utils/request.js